/* eslint jsx-a11y/label-has-for: 0 */
import React from 'react';
import PropTypes from 'prop-types';
// import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';

moment.locale('is');

const styles = {
  defaultInput: {
    outline: 'none',
    border: 'none',
    fontSize: 16,
    color: 'rgba(0,0,0,0.83)',
  },
};

class DateInput extends React.Component {
  // Cleanup before re-render
  componentWillUpdate() {
    if (this.dateInput && this.dateInput.hasAttribute('data-has-picker')) {
      this.dateInput.removeEventListener('change', this.dateChanged);
    }
  }

  // If we have a date input and it has a picker attribute bind the event
  componentDidUpdate() {
    if (this.dateInput && this.dateInput.hasAttribute('data-has-picker')) {
      this.dateInput.addEventListener('change', this.dateChanged);
    }
  }

  dateChanged = (event) => {
    const value = event.target.value;
    if (value) {
      const date = new Date(value);
      this.props.input.onChange(date ? date.toISOString() : '');
    }
  }

  render() {
    const {
      input, label, meta: {
        active, error, warning, touched,
      }, disabled,
    } = this.props;
    return (
      <div className="date-root">
        <label htmlFor={input.name} className="date-label">
          {label}
        </label>
        <input
          value={input.value ? input.value.split('T')[0] : undefined}
          id={input.name}
          disabled={disabled}
          type="date"
          style={styles.defaultInput}
          ref={(inp) => { this.dateInput = inp; }}
          onChange={this.dateChanged}
          onBlur={() => input.onBlur()}
        />
        <div>
          <hr className="date-underline" />
          <hr className={`date-underline-active ${active ? 'date-underline-active-scale' : ''}`} />
          <hr className={`date-underline-error ${touched && (error || warning) ? 'date-underline-active-scale' : ''}`} />
        </div>
        {touched && (error || warning) && <div className="date-error-text">{error || warning}</div>}
      </div>
    );
  }
}

DateInput.propTypes = {
  input: PropTypes.object,
  label: PropTypes.node.isRequired,
  meta: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
};

export default DateInput;



// WEBPACK FOOTER //
// ./src/components/form/DateInput.js